module.exports = __webpack_public_path__ + "dcc44b91deb9d47bbfdd0795e0dd3b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/aboutus/one/one-kuang.png
// module id = 1091
// module chunks = 0